'use strict';
import React, { PureComponent } from 'react';
import getExcelHelper from '../../../../../Common/Helpers/GetExcelHelper';

class ModalProceso extends PureComponent {

    componentDidMount(){
        $('[data-toggle="tooltip"]').tooltip();
    }

    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }
    
    constructor(props) {
        super(props);

        this.validarEjecucionProceso = this.validarEjecucionProceso.bind(this);
        this.descargarExcel = this.descargarExcel.bind(this);
    }

    validarEjecucionProceso(nombreProceso) {
        this.props.validarEjecucionProceso(nombreProceso,false);
    }

    descargarExcel(registroEjecucionDetalle, datosRegistroSeleccionado) {
        this.props.descargarExcel(registroEjecucionDetalle,datosRegistroSeleccionado, false);
    }

    render() {
        const { 
            datosCombo,
            esContabilizacion,
            hayProcesosEnEjecucion,
            idRegistro,
            registroEjecucionCabecera,
            registroEjecucionDetalle
        } = this.props;

        let fechaInput = "";
        let horaInput = "";
        let fechaInputFin = "";
        let horaInputFin = "";

        let estiloEstadoProceso = "";
        let descripcionEstadoProceso = "";

        let datosRegistroSeleccionado = datosCombo.find(registro => registro.TrazaEjecucion == idRegistro);
        let textoTruncado = registroEjecucionDetalle[0].Mensaje;
        let mostrarBotonExportarNotas = registroEjecucionDetalle.length > 0 && datosRegistroSeleccionado.Nombre != "Eliminación Asientos" && datosRegistroSeleccionado.Nombre != "Consolidación de asientos";
           
        if (registroEjecucionDetalle && registroEjecucionDetalle.length > 0) {
            const fechaHora = registroEjecucionDetalle[0].Fecha.split("T");

            let fechaHoraFin = registroEjecucionDetalle[0].Fecha ? 
            registroEjecucionDetalle[0].Fecha.split("T") 
            : 
            "-";
            const fechaFormateada = `${fechaHora[0].split("-")[2]}/${fechaHora[0].split("-")[1]}/${fechaHora[0].split("-")[0]}`;
            const fechaFormateadaFin = fechaHoraFin === "-" ? "-" : `${fechaHoraFin[0].split("-")[2]}/${fechaHoraFin[0].split("-")[1]}/${fechaHoraFin[0].split("-")[0]}`;
            let horaFormateada =  `${fechaHora[1].split(":")[0]}:${fechaHora[1].split(":")[1]}`;
            let horaFormateadaFin = fechaHoraFin === "-" ? "-" : `${fechaHoraFin[1].split(":")[0]}:${fechaHoraFin[1].split(":")[1]}`;  

            fechaInput = fechaFormateada;
            horaInput = horaFormateada;
            fechaInputFin = fechaFormateadaFin;
            horaInputFin = horaFormateadaFin;
        }

        switch (registroEjecucionCabecera[0].ColorResultado) {
            case "VERDE":
                estiloEstadoProceso = " ContabilizadorRecontabilizador__registroProceso--ProcesoOk";
                descripcionEstadoProceso = "Procesamiento OK";
            break;

            case "ROJO":
                estiloEstadoProceso = " ContabilizadorRecontabilizador__registroProceso--ProcesoError";
                descripcionEstadoProceso = "Procesamiento finalizado con error";
            break;

            case "AZUL":
                estiloEstadoProceso = " ContabilizadorRecontabilizador__registroProceso--ProcesoEnEjecucion";
                descripcionEstadoProceso = "Procesamiento en ejecución";
            break;

            default:
            break;
        }

        if(textoTruncado && textoTruncado.length > 50){
            textoTruncado = textoTruncado.substring(0,50) + "...";
        }

        return (
            <div className="modalContainer">
                <div className="ABMModelosModalContainer ContabilizadorRecontabilizador__modalProcesoContainer">
                    <div className="ABMModelosModalContainer__header">
                        <div className="ABMModelosModalContainer__contenedorTituloBoton">
                            <div className="ABMModelosModalContainer__titulo AsientosContables__modalDetalleAsiento__titulo">Log de última ejecución de procesos</div>
                            <div className="ABMModelosModalContainer__botonCerrar" onClick={() => this.props.mostrarOcultarModalContabilizadorRecontabilizador("modalProceso", false)}></div>
                        </div>

                        <div className="AsientosContables__modalDetalleAsiento__lineaDivisoria ContabilizadorRecontabilizador__lineaDivisoriaModalProceso"></div>
                    </div>

                    <div className="ABMModelosModalContainer__body">
                        <div className={"ContabilizadorRecontabilizador__modalProcesoCabecera AsientosContables--overflowHidden" + estiloEstadoProceso}>
                            <div className="AsientosContables--floatLeft">{datosRegistroSeleccionado.Descripcion}</div>

                            <div className="AsientosContables--floatRight ContabilizadorRecontabilizador__modalProcesoCabeceraDerecha">
                                <div>{descripcionEstadoProceso}</div>
                                <div className="ContabilizadorRecontabilizador__modalProcesoCabeceraDerechaRegistros">{registroEjecucionCabecera[0].CantidadRegistrosOriginal + ' Registros totales'}</div>
                            </div>
                        </div>
                        <div className="ContabilizadorRecontabilizador__modalProcesoDetalleRenglon">Log</div>
                        <div className="ContabilizadorRecontabilizador__modalProcesoDetalle">
                            <div className={"ContabilizadorRecontabilizador__modalProcesoDetalleRenglon"  + estiloEstadoProceso}>
                                <div className="AsientosContables--floatLeft">ID procesamiento {datosRegistroSeleccionado.TrazaEjecucion}</div>
                                <div className="AsientosContables--floatRight">{registroEjecucionCabecera[0].DescripcionProcesoEstado}</div>
                            </div>
                        </div>
                        <div className= {registroEjecucionDetalle.length > 2 ? 'modalLogIntentosScroll procesosScrollModalProcesos' : ''}>
                            {registroEjecucionDetalle.length > 0 ?
                                registroEjecucionDetalle.map(() => (
                                    <div className="ContabilizadorRecontabilizador__modalProcesoDetalle ContabilizadorRecontabilizador__modalProcesoDetallePadding">
                                        <div className="ContabilizadorRecontabilizador__modalProcesoDetalleRenglon ContabilizadorRecontabilizador__modalProcesoDetallePadding">
                                        <div className="ContabilizadorRecontabilizador__modalProcesoDetalleRenglon">
                                            <div className="AsientosContables--floatLeft">{fechaInputFin + " " + horaInputFin}</div>
                                            <div className="AsientosContables--floatRight ContabilizadorRecontabilizador--paddingRigth" data-toggle="tooltip" data-title={registroEjecucionDetalle[0].Mensaje} data-placement="right">{textoTruncado}</div>
                                        
                                        </div>
                                        </div>
                                        <div className="AsientosContables__lineaDivisoria ContabilizadorRecontabilizador__modalProcesoDetalleLineaDivisoriaRenglon"></div>

                                    </div>
                                ))
                            : 
                                null
                            }
                        </div>
                    </div>
                    
                    <div className="ABMModelosModalContainer__footer">
                        {mostrarBotonExportarNotas &&
                                <div>
                                    <button className="ABMModelosModalContainer__botonCancelar ContabilizadorRecontabilizador__botonExportarNotas"  onClick={() => this.descargarExcel(registroEjecucionDetalle, datosRegistroSeleccionado)}>
                                        Exportar notas
                                    </button>
                                </div>
                        }

                        {(esContabilizacion && !hayProcesosEnEjecucion) &&
                            <div>
                                <button className="ABMModelosModalContainer__botonAceptar ContabilizadorRecontabilizador__botonEjecucionIndividual" onClick={() => this.validarEjecucionProceso(datosRegistroSeleccionado.Nombre)}>
                                    Ejecución individual
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}
    

export default ModalProceso;
